import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { tenantValidityGuard } from './guards/tenant-validity-guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/supplier-portal/supplier-portal.component'),
    canActivate: [AuthGuard]
  },
  {
    path: 'org/:tenantId',
    loadComponent: () =>
      import('./components/supplier-portal/supplier-portal.component'),
    canActivate: [AuthGuard, tenantValidityGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: 'error',
    loadComponent: () => import('./error-page/error-page.component')
  },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component')
  }
];
